export interface ScanSignalEvent {
  agentType?: string;
  eventType?: string;
  label?: string;
  detail?: Record<string, unknown>;
}

/**
 * How many findings one scan event represents. Every branch reads a real count
 * off the event: a page the crawler finished, the images the curator says it
 * annotated, a query a citation checker actually ran, an agent that completed.
 * Nothing here estimates, so a run's final total is its event count by
 * construction rather than by coincidence.
 */
export function signalDeltaForEvent(event: ScanSignalEvent): number {
  const { agentType, eventType, label, detail } = event;

  if (eventType === 'completed') {
    // analysis-ready is the handoff to the reveal, not an agent finishing work.
    return agentType && agentType !== 'analysis-ready' ? 1 : 0;
  }

  if (eventType !== 'step') return 0;

  if (agentType === 'site-page-fetcher' && label === 'page-done') return 1;

  if (label === 'verifying') return 1;

  if (agentType === 'image-curator' && label === 'done') {
    const curated = detail?.curated;
    return typeof curated === 'number' && curated > 0 ? curated : 0;
  }

  const isCitationChecker = agentType === 'google-citation-checker' || agentType === 'ai-citation-checker';
  if (isCitationChecker && label === 'analyzing' && detail?.phase === 'check-query') return 1;

  return 0;
}
